import React from "react";
import { Helmet } from "react-helmet-async";
import { SITE_URL, OG_IMAGE, SITE_NAME } from "@/lib/seo";

const DEFAULT_DESC =
  "India's Ethanol Economy & Biofuel Leadership Forum — 28–29 Sept 2026, Mumbai. A B2B conference + tech expo on E20/E30 blending, flex-fuel, 2G, CBG and SAF.";

export default function Seo({ title, description, path = "/", keywords, image, noindex = false, jsonLd = [] }) {
  const desc = description || DEFAULT_DESC;
  const canonical = `${SITE_URL}${path === "/" ? "" : path}`;
  const ogImage = image || OG_IMAGE;
  const blocks = Array.isArray(jsonLd) ? jsonLd.filter(Boolean) : [jsonLd];

  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={desc} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonical} />
      {noindex ? (
        <meta name="robots" content="noindex, follow" />
      ) : (
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      )}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />

      {blocks.map((b, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(b)}</script>
      ))}
    </Helmet>
  );
}
